import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import * as React from 'react'
import { useEditSampleRun } from '../../APIs/Hooks/SampleRunHooks'
import { tsGetSampleRun } from '../../Typescript/API_Response'

function DialogFinishRun({
  open,
  setOpen,
  sampleRun,
}: {
  open: boolean
  setOpen: any
  sampleRun: tsGetSampleRun | undefined
}) {
  const { mutate: submitChange } = useEditSampleRun(sampleRun, setOpen)

  return (
    <Dialog
      aria-label={'Finish Run Dialog'}
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogTitle>{'Finish Sample Run?'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please complete the current Container Sample id's, you will not be
          able to add further samples to this sample run. The status of this
          sample run will be marked as prepared. Continue?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(false)}
          color="error"
        >
          Cancel
        </Button>
        <Button
          onClick={() => submitChange('ACT')}
          color="warning"
        >
          Finish Sample Run
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogFinishRun
